<template>
  <div class="detail">
    <div class="category">{{ $t('page.materialDetail') }}</div>
    <div class="title">
      <img src="@/assets/img/d1.png" alt="" />
      {{ $t('page.inventoryInfo') }}
    </div>
    <Row type="flex">
      <Col span="8">
        <span class="key">{{ $t('columns.barcode') }}：</span>
        {{ dto.BottleInfo.Barcode }}
      </Col>
      <Col span="8">
        <span class="key">{{ $t('columns.bottleName') }}：</span>
        {{ dto.BottleInfo.BottleName }}
      </Col>
      <Col span="8">
        <span class="key">{{ $t('page.warehouse') }}：</span>
        {{ dto.BottleInfo.State === enums.bottleState.inStock ? dto.BottleInfo.WarehouseName : '' }}
      </Col>
    </Row>
    <Row type="flex">
      <Col span="8">
        <span class="key">{{ $t('columns.sublocation') }}：</span>
        {{ dto.BottleInfo.State === enums.bottleState.inStock ? dto.BottleInfo.Sublocation : '' }}
      </Col>
      <Col span="8">
        <span class="key">{{ $t('columns.initialQuantity') }}：</span>
        {{ dto.BottleInfo.InitialQuantity + dto.BottleInfo.UnitText }}
      </Col>
      <Col span="8">
        <span class="key">{{ dto.BottleInfo.CategoryCode === CR ? $t('columns.purity') : $t('columns.purity1') }}：</span>
        {{ dto.BottleInfo.Purity }}
      </Col>
    </Row>
    <Row type="flex">
      <Col span="8">
        <span class="key">{{ $t('columns.currentQuantity') }}：</span>
        {{ dto.BottleInfo.CurrentQuantity + dto.BottleInfo.UnitText }}
      </Col>
      <Col span="8">
        <span class="key">{{ $t('columns.bottleType') }}：</span>
        {{ dto.BottleInfo.BottleType }}
      </Col>
      <Col span="8">
        <span class="key">{{ $t('columns.expiryDate') }}：</span>
        {{ dto.BottleInfo.ExpiryDate.substring(0, 10) }}
        <span v-if="iminentExpirationDay" v-html="isExpiry(dto.BottleInfo.ExpiryDate)" style="margin-left: 5px"></span>
      </Col>
    </Row>
    <Row type="flex" class="border-bottom">
      <Col span="8">
        <span class="key">{{ $t('columns.origin') }}：</span>
        {{ dto.BottleInfo.OriginDescription }}
      </Col>
      <Col span="8" v-if="dto.BottleInfo.GrossWeight">
        <span class="key">{{ $t('columns.grossWeight') }}：</span>
        {{ dto.BottleInfo.GrossWeight }}{{ dto.BottleInfo.UnitText }}
      </Col>
    </Row>

    <div class="title">
      <img src="@/assets/img/d4.png" alt="" />
      {{ $t('btn.purchaseInfo') }}
    </div>
    <Row type="flex">
      <Col span="8">
        <span class="key">{{ $t('columns.poNumber') }}：</span>
        <span class="flex-1">{{ dto.BottleInfo.PONumber }}</span>
      </Col>
      <Col span="8">
        <span class="key">{{ $t('columns.price') }}：</span>
        <span class="flex-1">{{ dto.BottleInfo.UnitPrice }}</span>
      </Col>
      <Col span="8">
        <span class="key">{{ $t('page.supplier') }}：</span>
        <span class="flex-1">{{ dto.BottleInfo.Supplier }}</span>
      </Col>
    </Row>
    <Row type="flex">
      <Col span="8">
        <span class="key">{{ $t('columns.lotNumber') }}：</span>
        <span class="flex-1">{{ dto.BottleInfo.LotNumber }}</span>
      </Col>
      <Col span="8">
        <span class="key">{{ $t('columns.producer') }}：</span>
        <span class="flex-1">{{ dto.BottleInfo.Producer }}</span>
      </Col>
      <Col span="8">
        <span class="key">{{ $t('columns.catalogNumber') }}：</span>
        <span class="flex-1">{{ dto.BottleInfo.CatalogNumber }}</span>
      </Col>
    </Row>
    <Row type="flex">
      <Col span="8">
        <span class="key">{{ $t('nav.projects') }}：</span>
        <span class="flex-1">
          <a @click="onClick">
            {{ dto.BottleInfo.ProjectCode }}
          </a>
        </span>
      </Col>
      <Col span="8">
        <span class="key">{{ $t('key21') }}：</span>
        <span class="flex-1">
          {{ dto.BottleInfo.StorageConditionText }}
        </span>
      </Col>
      <Col span="8">
        <span class="key">{{ $t('columns.applicant') }}：</span>
        <span class="flex-1">{{ dto.BottleInfo.Requisitioner }}</span>
      </Col>
    </Row>
    <Row type="flex" class="border-bottom">
      <Col span="8">
        <span class="key">{{ $t('columns.pruchasePrice') }}：</span>
        <span class="flex-1" v-if="dto.BottleInfo.PerWeightPrice">
          {{ dto.BottleInfo.PerWeightPrice }} {{ $t('page.yuan') }}/{{ dto.BottleInfo.UnitText }}
        </span>
      </Col>
      <Col span="8">
        <span class="key">{{ $t('columns.comment') }}：</span>
        <span class="flex-1">{{ dto.BottleInfo.Comments }}</span>
      </Col>
      <Col span="8" class="flex">
        <span class="key">{{ $t('page.attachment') }}：</span>
        <span class="flex-1" v-if="dto.MaterialLotAttachmentInfo">
          <p v-for="(item, index) in dto.MaterialLotAttachmentInfo.Attachments" :key="index">
            <a :href="getDingTalkLink(item.Path.replace(/#/g, '%23'))" :download="item.Name">{{ item.Name }}</a>
          </p>
        </span>
      </Col>
    </Row>

    <div class="title">
      <img src="@/assets/img/d1.png" alt="" />
      {{ $t('page.materielInfo') }}
    </div>
    <Row type="flex" class="border-bottom" :class="{ 'no-border': dto.BottleInfo.CategoryCode !== CR }">
      <Col>
        <div class="struct-img">
          <div v-if="isFromCms(dto.MaterielInfo.Source)">
            <a
              :href="getDingTalkLink(`${cms}/Chemical/Bottle/BottleView?status=2&code=${encodeURIComponent(dto.MaterielInfo.MaterielNumber)}`)"
              target="_blank"
            >
              {{ $t('key30') }}
            </a>
          </div>
          <div v-else :style="materielStyle"></div>
        </div>
      </Col>
      <Col class="flex-1" v-if="dto.BottleInfo.CategoryCode === CR">
        <Row type="flex">
          <Col span="24">
            <span class="key">{{ $t('form.chinName') }}：</span>
            {{ dto.CompoundInfo.ChinName }}
          </Col>
        </Row>
        <Row type="flex">
          <Col span="24">
            <span class="key">{{ $t('form.chemName') }}：</span>
            {{ dto.CompoundInfo.ChemName }}
          </Col>
        </Row>
        <Row type="flex">
          <Col span="24">
            <span class="key">{{ $t('form.chinAlias') }}：</span>
            {{ dto.CompoundInfo.Alias }}
          </Col>
        </Row>
        <Row type="flex">
          <Col span="24">
            <span class="key">{{ $t('form.chemAlias') }}：</span>
            {{ dto.CompoundInfo.ChemAlias }}
          </Col>
        </Row>
        <Row type="flex">
          <Col span="8">
            <span class="key">{{ $t('page.materielNumber') }}：</span>
            {{ dto.CompoundInfo.MaterielNumber }}
          </Col>
          <Col span="8">
            <span class="key">{{ $t('columns.CASNumber') }}：</span>
            {{ dto.CompoundInfo.CASNumber }}
          </Col>
          <Col span="8">
            <span class="key">{{ $t('columns.mdl') }}：</span>
            {{ dto.CompoundInfo.MDLNumber }}
          </Col>
        </Row>
        <Row type="flex">
          <Col span="8">
            <span class="key">{{ $t('page.molecularWeight') }}：</span>
            {{ dto.CompoundInfo.MolecularWeight }}
          </Col>
          <Col span="8">
            <span class="key">{{ $t('page.molecularFormula') }}：</span>
            <span v-html="formatChemicalFormula(dto.CompoundInfo.MolecularFormula)"></span>
          </Col>
          <Col span="8">
            <span class="key">{{ $t('page.accurateMass') }}：</span>
            {{ dto.CompoundInfo.ExactMass }}
          </Col>
        </Row>

        <Row type="flex">
          <Col span="24">
            <span class="key">{{ $t('page.appearance') }}：</span>
            {{ dto.CompoundInfo.AppearanceCharacter }}
          </Col>
        </Row>
        <Row type="flex">
          <Col span="24">
            <span class="key">{{ $t('page.stereoisomerDescription') }}：</span>
            {{ dto.CompoundInfo.SteroisomerDesc }}
          </Col>
        </Row>
      </Col>
      <Col class="flex-1" v-else>
        <Row type="flex">
          <Col span="24">
            <span class="key">{{ $t('page.materielNumber') }}：</span>
            {{ dto.MaterielInfo.MaterielNumber }}
          </Col>
        </Row>
        <Row type="flex">
          <Col span="24">
            <span class="key">{{ $t('form.chinName') }}：</span>
            {{ dto.MaterielInfo.ChinName }}
          </Col>
        </Row>
        <Row type="flex">
          <Col span="24">
            <span class="key">{{ $t('form.chinAlias') }}：</span>
            {{ dto.MaterielInfo.Alias }}
          </Col>
        </Row>
        <Row type="flex">
          <Col span="24">
            <span class="key">{{ $t('columns.categoryName') }}：</span>
            {{ dto.MaterielInfo.CategoryName }}
          </Col>
        </Row>
        <Row type="flex">
          <Col span="24">
            <span class="key">{{ $t('columns.note') }}：</span>
            {{ dto.MaterielInfo.Comments }}
          </Col>
        </Row>
        <Row type="flex" v-if="dto.BottleInfo.CategoryCode !== CR">
          <neo-custom-form :domain="cimsmanage" :data="customFormData" mode="view" hasColon></neo-custom-form>
        </Row>
      </Col>
    </Row>
    <div class="title" v-if="dto.BottleInfo.CategoryCode === CR">
      <img src="@/assets/img/d2.png" alt="" />
      {{ $t('page.chemProperty') }}
    </div>
    <Row type="flex" v-if="dto.BottleInfo.CategoryCode === CR">
      <Col span="6">
        <span class="key">{{ $t('page.density') }}：</span>
        {{ dto.CompoundInfo.Density }}
      </Col>
      <Col span="6">
        <span class="key">{{ $t('page.meltlingPoint') }}：</span>
        {{ dto.CompoundInfo.MeltlingPoint }}
      </Col>
      <Col span="6">
        <span class="key">{{ $t('page.boilingPoint') }}：</span>
        {{ dto.CompoundInfo.BoilingPoint }}
      </Col>
      <Col span="6">
        <span class="key">{{ $t('page.flashPoint') }}：</span>
        {{ dto.CompoundInfo.FlashPoint }}
      </Col>
    </Row>
    <Row type="flex" class="border-bottom" v-if="dto.BottleInfo.CategoryCode === CR">
      <Col span="24">
        <span class="key">{{ $t('page.stability') }}：</span>
        {{ dto.CompoundInfo.Stability }}
      </Col>
    </Row>
    <div class="title" v-if="dto.BottleInfo.CategoryCode === CR"><img src="@/assets/img/d3.png" alt="" />{{ $t('page.sAndr') }}</div>
    <Row type="flex" v-if="dto.BottleInfo.CategoryCode === CR">
      <Col span="24">
        <span style="min-width: 120px">{{ $t('page.incompatibilityInfo') }}：</span>
        {{ dto.IncompatibilityInfo ? `${dto.IncompatibilityInfo.Code.toString()}-${dto.IncompatibilityInfo.Name}` : '' }}
      </Col>
      <Col span="24">
        <span style="min-width: 120px">{{ $t('page.storageCondition') }}：</span>{{ dto.CompoundInfo.StorageCondition }}
      </Col>
    </Row>
    <Row type="flex" justify="space-between" v-if="dto.BottleInfo.CategoryCode === CR">
      <Col>
        <span>{{ $t('page.Toxic') }}：</span>{{ dto.CompoundInfo.Toxic > 0 ? $t('page.yes') : $t('page.no') }}
      </Col>
      <Col>
        <span>{{ $t('page.Pretoxic') }}：{{ dto.CompoundInfo.Pretoxic > 0 ? $t('page.yes') : $t('page.no') }}</span>
      </Col>
      <Col>
        <span>{{ $t('page.Dangerous') }}：{{ dto.CompoundInfo.Dangerous > 0 ? $t('page.yes') : $t('page.no') }}</span>
      </Col>
      <Col>
        <span>{{ $t('page.Explosives') }}：{{ dto.CompoundInfo.Explosives > 0 ? $t('page.yes') : $t('page.no') }}</span>
      </Col>
      <Col>
        <span>{{ $t('page.Psychotropic') }}：{{ dto.CompoundInfo.Psychotropic > 0 ? $t('page.yes') : $t('page.no') }}</span>
      </Col>
      <Col>
        <span>{{ $t('page.Narcotic') }}：{{ dto.CompoundInfo.Narcotic > 0 ? $t('page.yes') : $t('page.no') }}</span>
      </Col>
      <Col>
        <span>{{ $t('page.Radioactive') }}：{{ dto.CompoundInfo.Radioactive > 0 ? $t('page.yes') : $t('page.no') }}</span>
      </Col>
    </Row>
    <Row type="flex" v-if="dto.BottleInfo.CategoryCode === CR">
      <Col class="compound-icons">
        <img src="@/assets/img/Toxic.png" v-if="dto.CompoundInfo.Toxic" style="margin-right: 6px" :alt="$t('page.Toxic')" :title="$t('page.Toxic')" />
        <img
          src="@/assets/img/Pretoxic.png"
          v-if="dto.CompoundInfo.Pretoxic"
          style="margin-right: 6px"
          :alt="$t('page.Pretoxic')"
          :title="$t('page.Pretoxic')"
        />
        <img
          src="@/assets/img/Dangerous.png"
          v-if="dto.CompoundInfo.Dangerous"
          style="margin-right: 6px"
          :alt="$t('page.Dangerous')"
          :title="$t('page.Dangerous')"
        />
        <img
          src="@/assets/img/Explosives.png"
          v-if="dto.CompoundInfo.Explosives"
          class="risk"
          style="margin-right: 6px"
          :alt="$t('page.Explosives')"
          :title="$t('page.Explosives')"
        />
        <img
          src="@/assets/img/Psychotropic.png"
          v-if="dto.CompoundInfo.Psychotropic"
          class="risk"
          style="margin-right: 6px"
          :alt="$t('page.Psychotropic')"
          :title="$t('page.Psychotropic')"
        />
        <img
          src="@/assets/img/Narcotic.png"
          v-if="dto.CompoundInfo.Narcotic"
          class="risk"
          style="margin-right: 6px"
          :title="$t('page.Narcotic')"
          alt=""
        />
        <img
          src="@/assets/img/Radioactive.png"
          v-if="dto.CompoundInfo.Radioactive"
          class="risk"
          style="margin-right: 6px"
          :title="$t('page.Radioactive')"
          alt=""
        />
      </Col>
    </Row>
    <Row type="flex" v-if="dto.BottleInfo.CategoryCode === CR">
      <Col span="24">
        <span style="float: left">{{ $t('page.gb') }}：</span>
        <span
          class="compound-icons"
          v-for="(item, index) in dto.CompoundInfo && dto.CompoundInfo.Symbol ? dto.CompoundInfo.Symbol.split(',') : []"
          :key="index"
        >
          <img
            src="@/assets/img/explosive.png"
            v-if="item === $t('page.gb1')"
            class="risk"
            style="margin-right: 6px"
            :title="$t('page.gb1')"
            alt=""
          />
          <img
            src="@/assets/img/corrosive.png"
            v-else-if="item === $t('page.gb2')"
            class="risk"
            style="margin-right: 6px"
            :title="$t('page.gb2')"
            alt=""
          />
          <img
            src="@/assets/img/compressed.png"
            v-else-if="item === $t('page.gb3')"
            class="risk"
            style="margin-right: 6px"
            :title="$t('page.gb3')"
            alt=""
          />
          <img
            src="@/assets/img/environment.png"
            v-else-if="item === $t('page.gb4')"
            class="risk"
            style="margin-right: 6px"
            :title="$t('page.gb4')"
            alt=""
          />
          <img
            src="@/assets/img/health.png"
            v-else-if="item === $t('page.gb5')"
            class="risk"
            style="margin-right: 6px"
            :title="$t('page.gb5')"
            alt=""
          />
          <img
            src="@/assets/img/oxidizing.png"
            v-else-if="item === $t('page.gb6')"
            class="risk"
            style="margin-right: 6px"
            :title="$t('page.gb6')"
            alt=""
          />
          <img
            src="@/assets/img/flammable.png"
            v-else-if="item === $t('page.gb7')"
            class="risk"
            style="margin-right: 6px"
            :title="$t('page.gb7')"
            alt=""
          />
          <img
            src="@/assets/img/Toxic.png"
            v-else-if="item === $t('page.gb8')"
            class="risk"
            style="margin-right: 6px"
            :title="$t('page.gb8')"
            alt=""
          />
          <img
            src="@/assets/img/harmful.png"
            v-else-if="item === $t('page.gb9')"
            class="risk"
            style="margin-right: 6px"
            :title="$t('page.gb9')"
            alt=""
          />
        </span>
      </Col>
    </Row>
    <Row type="flex" v-if="dto.BottleInfo.CategoryCode === CR">
      <Col span="24">
        <span class="key">{{ $t('page.om') }}：</span>
        {{ dto.CompoundInfo.RiskSymbol }}
      </Col>
    </Row>
    <Row type="flex" v-if="dto.BottleInfo.CategoryCode === CR">
      <Col span="24" class="flex">
        <span class="key">{{ $t('page.om1') }}：</span>
        <span>{{ dto.CompoundInfo.RiskPhrases }}</span>
      </Col>
    </Row>
    <Row type="flex" v-if="dto.BottleInfo.CategoryCode === CR">
      <Col span="24" class="flex">
        <span class="key">{{ $t('page.om2') }}：</span>
        <span>{{ dto.CompoundInfo.HazardInfo }}</span>
      </Col>
    </Row>
    <Row type="flex" v-if="dto.BottleInfo.CategoryCode === CR">
      <Col span="24" class="flex">
        <span class="key">{{ $t('page.om3') }}：</span>
        <span>{{ dto.CompoundInfo.SafetyPhrases }}</span>
      </Col>
    </Row>
    <Row type="flex" v-if="dto.BottleInfo.CategoryCode === CR">
      <Col span="24" class="flex">
        <span class="key">{{ $t('page.om4') }}：</span>
        <span>{{ dto.CompoundInfo.WarningStatement }}</span>
      </Col>
    </Row>
    <Row type="flex" class="border-bottom" v-if="dto.BottleInfo.CategoryCode === CR">
      <Col span="24" class="flex">
        <span class="key">{{ $t('page.om5') }}：</span>
        <span>{{ dto.CompoundInfo.StorageRequirement }}</span>
      </Col>
    </Row>

    <div class="title" v-if="dto.BottleInfo.CategoryCode === CR"><img src="@/assets/img/d5.png" alt="" />MSDS</div>
    <Row type="flex" class="border-bottom" v-if="dto.BottleInfo.CategoryCode === CR">
      <Col span="24">
        <span class="key">MSDS：</span>
        <a
          v-if="dto.CompoundInfo.MSDS"
          :href="getDingTalkLink(dto.CompoundInfo.MSDS.replace(/#/g, '%23'))"
          :download="dto.CompoundInfo.MSDS.substr(dto.CompoundInfo.MSDS.lastIndexOf('/') + 1)"
        >
          {{ dto.CompoundInfo.MSDS.substr(dto.CompoundInfo.MSDS.lastIndexOf('/') + 1) }}</a
        >
        <span v-else>{{ $t('page.not') }}</span>
      </Col>
    </Row>

    <div class="title" v-if="dto.BottleInfo.CategoryCode === CR">
      <img src="@/assets/img/d2.png" alt="" />
      {{ $t('page.toxicityInfo') }}
    </div>
    <Row type="flex" class="border-bottom" v-if="dto.BottleInfo.CategoryCode === CR">
      <Col span="24">
        <span class="key">{{ $t('page.toxicityInfo') }}：</span>
        <a
          v-if="dto.CompoundInfo.ToxicityInfo"
          :href="getDingTalkLink(dto.CompoundInfo.ToxicityInfo.replace(/#/g, '%23'))"
          :download="dto.CompoundInfo.ToxicityInfo.substr(dto.CompoundInfo.ToxicityInfo.lastIndexOf('/') + 1)"
        >
          {{ dto.CompoundInfo.ToxicityInfo.substr(dto.CompoundInfo.ToxicityInfo.lastIndexOf('/') + 1) }}
        </a>
        <span v-else>{{ $t('page.not') }}</span>
      </Col>
    </Row>

    <div class="title" v-if="dto.BottleInfo.CategoryCode === CR"><img src="@/assets/img/d4.png" alt="" />{{ $t('page.other') }}</div>
    <Row type="flex" class="border-bottom no-border" v-if="dto.BottleInfo.CategoryCode === CR">
      <Col span="6">
        <span class="key">{{ $t('page.customNumber') }}：</span>
        {{ dto.CompoundInfo.SelfNumber }}
      </Col>
      <Col span="6">
        <span class="key">{{ $t('form.waste19') }}：</span>
        {{ dto.CompoundInfo.Origin }}
      </Col>
      <Col span="6">
        <span class="key">{{ $t('page.OHS1') }}：</span>
        {{ dto.CompoundInfo.OHSNumber }}
      </Col>
      <Col span="6">
        <span class="key">{{ $t('page.OHS2') }}：</span>
        {{ dto.CompoundInfo.OHSName }}
      </Col>
    </Row>

    <div class="category">{{ $t('page.requestInfo') }}</div>
    <Table :columns="columns" :data="dto.RequestInfo || []">
      <template slot-scope="{ row }" slot="Action">
        <Button type="primary" size="small" @click="openApplicantHistory(row.StateHistory)">{{ $t('page.requesthistory') }}</Button>
        <Button type="primary" size="small" @click="openApproveHistory(row.ApprovalHistory)">{{ $t('page.approvehistory') }}</Button>
      </template>
    </Table>

    <Modal :title="$t('page.requesthistory')" v-model="modal1" footer-hide :width="600">
      <Table :columns="columns1" :data="data1"></Table>
    </Modal>

    <Modal :title="$t('page.approvehistory')" v-model="modal2" footer-hide :width="600">
      <Table :columns="columns2" :data="data2"></Table>
    </Modal>

    <div class="category">{{ $t('page.lifeCycle') }}</div>
    <Timeline>
      <TimelineItem v-for="(item, index) in dto.LifecycleInfo" :key="index">
        <p class="content">
          {{ item.Comment.replace($t('page.library'), $t('page.putIn')) }}
        </p>
        <p v-if="item.Reason">{{ item.Reason }}</p>
        <p class="time">{{ item.CreateTime }}</p>
      </TimelineItem>
    </Timeline>
  </div>
</template>

<script>
  import neoCustomForm from '@neotrident/neo-custom-form';
  import utils from '@/utils/utils';
  import { getDingTalkLink } from '@/utils/utils';
  import api from '@/api';
  import Vue from 'vue';
  import Vddl from 'vddl';
  import Vuebar from 'vuebar';
  import enums from '@/utils/enums';

  Vue.use(Vddl);
  Vue.use(Vuebar);
  const { structurePrefix, materielPrefix } = utils.getStructImagePrefix();
  export default {
    name: 'Detail',
    components: {
      neoCustomForm,
    },
    props: {
      barcode: {
        type: String,
        default: '',
      },
      requesterId: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        enums,
        structurePrefix,
        materielPrefix,
        cimsmanage: config.site.cimsmanage,
        cms: config.site.cms,
        CR: process.env.VUE_APP_CR,
        iminentExpirationDay: '',
        dto: {
          BottleInfo: {
            ExpiryDate: '',
            PartialDate: '',
            CategoryCode: process.env.VUE_APP_CR,
          },
          CompoundInfo: {
            Symbol: '',
            MeltlingPoint: '',
            Stability: '',
          },
          MaterielInfo: {},
        },
        modal1: false,
        modal2: false,
        data: [],
        data1: [],
        data2: [],
        columns: [
          {
            title: this.$i18n.t('columns.requestCode'),
            key: 'RequestCode',
          },
          {
            title: this.$i18n.t('form.projectCode'),
            key: 'ProjectCode',
          },
          {
            title: this.$i18n.t('columns.requestQuantity'),
            key: 'RequestQuantity',
          },
          {
            title: this.$i18n.t('columns.requestUnit'),
            key: 'RequestUnit',
          },
          {
            title: this.$i18n.t('columns.requester'),
            key: 'Requester',
          },
          {
            title: this.$i18n.t('columns.requestDate'),
            key: 'RequestDate',
            width: 180,
          },
          {
            title: this.$i18n.t('columns.operation'),
            slot: 'Action',
            align: 'center',
            width: 200,
          },
        ],
        columns1: [
          {
            title: this.$i18n.t('columns.requester'),
            key: 'CreateUser',
          },
          {
            title: this.$i18n.t('columns.createTime'),
            key: 'CreateTime',
            width: 180,
          },
          {
            title: this.$i18n.t('columns.state'),
            key: 'RequestStateName',
          },
          {
            title: this.$i18n.t('columns.comment'),
            key: 'Comment',
          },
        ],
        columns2: [
          {
            title: this.$i18n.t('columns.approveUsersNames'),
            key: 'ApproveUser',
          },
          {
            title: this.$i18n.t('columns.approveTime'),
            key: 'ApproveTime',
            width: 180,
          },
          {
            title: this.$i18n.t('columns.state'),
            key: 'ApproveStateName',
          },
          {
            title: this.$i18n.t('form.approvalIdea'),
            key: 'ApproveReason',
            render: (h, params) => {
              return h('div', params.row.ApproveReason || this.$i18n.t('btn.yes'));
            },
          },
        ],
        customFormData: [],
        materielStyle: {
          backgroundImage: '',
        },
      };
    },
    methods: {
      //领用
      async submitRequest() {
        const stock = this.dto.BottleInfo;
        const resp = await api.cims.submitRequest({
          amount: 300,
          foreignKeyId: stock.WarehouseId,
          fKID: stock.ID,
          chinName: stock.ChinName,
          compoundId: stock.CompoundId,
          materielId: stock.MaterielId,
          requestType: 1,
          requestUnit: stock.Unit,
          requestQuantity: stock.CurrentQuantity,
          barcode: stock.Barcode,
          lab: utils.getCimsInfo().UserInfo.LabName,
          phone: utils.getUcInfo().AccountInfo.MobilePhone,
          warehouseId: stock.WarehouseId,
          bottleName: stock.BottleName,
          casNumber: stock.CASNumber,
          mdlNumber: stock.MDLNumber,
        });
        if (resp.code == process.env.VUE_APP_code) {
          this.$Message.success({ content: resp.message });
        } else {
          this.$Message.warning({ content: resp.message });
        }
        return resp;
      },
      getDingTalkLink,
      formatChemicalFormula: utils.formatChemicalFormula,
      //获取物料近效期提醒时间
      async getIminentExpirationDay() {
        const resp = await api.cims.getOrganizationConfig('iminentExpirationDay');
        if (resp.code == process.env.VUE_APP_code) {
          this.iminentExpirationDay = resp.response;
        } else {
          this.$Message.error(resp.message);
        }
      },
      //判断近效期
      isExpiry(date) {
        return utils.isExpiry(this.iminentExpirationDay, date, this);
      },
      //物料详情
      async getReagent() {
        if (this.barcode) {
          const resp = await api.cims.getReagent({
            barcode: this.barcode,
            requesterId: this.requesterId,
          });
          if (resp.code == process.env.VUE_APP_code) {
            this.dto = resp.response;
            if (resp.response.MaterielDataInfo && resp.response.MaterielDataInfo.CustomColumnsValues) {
              this.customFormData = JSON.parse(resp.response.MaterielDataInfo.CustomColumnsValues);
            }
            if (this.dto.BottleInfo.CategoryCode === this.CR) {
              this.materielStyle = {
                backgroundImage: `url(${this.structurePrefix}${encodeURIComponent(this.dto.MaterielInfo.Photo)})`,
              };
            } else {
              this.materielStyle = {
                backgroundImage: `url(${this.addRandom2Url(this.materielPrefix + this.dto.MaterielInfo.Photo)})`,
              };
            }
          }
        }
      },
      //领用历史
      openApplicantHistory(data) {
        this.data1 = data;
        this.modal1 = true;
      },
      //审批历史
      openApproveHistory(data) {
        this.data2 = data;
        this.modal2 = true;
      },
      //结构式图片URL添加随机数
      addRandom2Url: url => utils.addRandom2Url(url),
      // 点击所属项目
      onClick() {
        if (this.dto.BottleInfo.ProjectOrigin === 'PM') {
          window.location.href = `${config.site.pm}/#/app/project?id=${this.dto.BottleInfo.OriginProjectId}`;
        } else {
          this.$Message.warning(this.$t('key22'));
        }
      },
      isFromCms: utils.isFromCms,
    },
    async mounted() {
      await this.getIminentExpirationDay();
    },
    watch: {
      barcode: function (barcode) {
        if (barcode) {
          this.getReagent();
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  .content {
    .detail {
      border: 1px solid #ddd;
      padding: 0 30px 30px 30px;
      font-size: 15px;

      .category {
        font-size: 16px;
        font-weight: bold;
        display: block;
        margin: -1px -30px;
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        padding: 8px 30px;
        margin-bottom: 30px;
      }

      .title {
        font-size: 16px;
        color: #3496ed;
        font-weight: bold;
        margin-bottom: 6px;

        img {
          position: relative;
          top: 3px;
          margin-right: 10px;
        }
      }

      .compound-icons {
        img {
          width: 60px;
        }
      }

      .ivu-row-flex {
        padding-left: 25px;

        .flex-1 {
          flex: 1;
          word-break: break-all;
        }

        .ivu-col.ivu-col-span-8,
        .flex {
          display: flex;
        }

        .key {
          display: inline-block;
          width: 120px;
          text-align: right;
        }

        &.border-bottom {
          border-bottom: 1px solid #ddd;
          margin-bottom: 20px;
          padding-bottom: 15px;

          &.no-border {
            border-bottom: none;
          }
        }
      }

      .struct-img {
        text-align: center;
        border-right: 1px solid #ddd;
        margin-bottom: 24px;
        padding-right: 12px;
        width: 190px;

        div {
          background-position: center center;
          background-repeat: no-repeat;
          background-size: contain;
          height: 165px;
          margin-right: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .ivu-col {
        padding: 8px 0;
      }

      .ivu-table-wrapper {
        margin-bottom: 35px;
      }

      .chinName {
        margin: 16px 0 6px 0;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .time {
        margin-top: 8px;
      }

      .content {
        font-size: 14px;
      }

      .chemName {
        color: #a3a3a3;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .flex {
      display: flex;
    }
  }
</style>
<style lang="less">
  .reagent-detail {
    .neo-form {
      width: 100%;

      .neo-body {
        .form-row-item .component {
          padding-left: 16px;

          .component-title {
            width: 120px;
            padding-right: 6px;
          }
        }

        .component.container-row-item {
          padding-left: 0;
        }
      }
    }
  }
</style>
